module.exports = __webpack_public_path__ + "static/img/shengxian.1fb6b61.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shengxian.png
// module id = SLKC
// module chunks = 0